import { isValidAutomergeUrl, } from "@automerge/automerge-repo/slim";
export function getType(doc) {
    return doc["@patchwork"]?.type;
}
export function isHttpUrl(url) {
    if (!url)
        return false;
    try {
        const { protocol } = new URL(url);
        return protocol === "https:" || protocol === "http:";
    }
    catch {
        return false;
    }
}
/**
 * A `suggestedImportUrl` is only honored when it names a directly-importable
 * module: either an `http:`/`https:` URL (a module bundle served over the
 * network) or an `automerge:` URL (a folder doc imported via the service
 * worker, like {@link importPackageFromFolderDocUrl}). Anything else is ignored
 * so a stray value is never treated as a module.
 */
export function isImportableSuggestedUrl(url) {
    return isHttpUrl(url) || isValidAutomergeUrl(url);
}
export function getSuggestedImportUrl(doc) {
    const url = doc["@patchwork"]?.suggestedImportUrl;
    return isImportableSuggestedUrl(url) ? url : undefined;
}
export function getCopies(doc) {
    return doc["@patchwork"]?.copies || [];
}
export function getCopyOf(doc) {
    return doc["@patchwork"]?.copyOf;
}
